import { render, staticRenderFns } from "./note-readonly.vue?vue&type=template&id=1514e410"
import script from "./note-readonly.vue?vue&type=script&lang=js"
export * from "./note-readonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports